import LegoIcon from '../../components/Icon';

const StatBase = {
    data () {
        return { hover : false };
    },
    props : {
        /**
         * Background color of the widget
         */
        color : { type : String, default : 'primary' },

        /**
         * Hover color of the widget
         */
        hoverColor : { type : String, default : 'success' },

        /**
         * If the background is in gradient mode
         */
        gradientMode  : { type : String, default : '' },
        gradientValue : { type : String, default : '7' },

        /**
         * The background mode. Colored or bordered
         * @values bg, bordered
         */
        mode : { type : String, default : 'bg' },

        icon                : { type : String, required : true },
        iconSize            : { type : String, default : '3' },
        iconCircle          : { type : Boolean, default : false },
        iconAlignmentInvert : { type : Boolean, default : false },

        number     : { type : [Number, String], required : true },
        numberSize : { type : String, default : '4' },

        coloredIcon   : { type : Boolean, default : false },
        coloredNumber : { type : Boolean, default : false },
        coloredName   : { type : Boolean, default : false },

        name                : { type : String, required : true },
        nameAlignmentInvert : { type : Boolean, default : false },

        longText : { type : String, default : '' },
        shadow   : { type : String, default : '11' },

        yAxis : { type : Boolean, default : false }
    },
    components : { LegoIcon },
    computed   : {
        currentColor () {
            const color = this.color;
            if (this.hover) {
                const hoverColor = this.hoverColor;
                if (hoverColor && hoverColor !== color) {
                    return hoverColor;
                }
            }
            return color;
        },

        currentBgColor () {
            const color = this.currentColor;
            let bgColor = 'bg-' + color;
            if (this.gradientMode) {
                bgColor = 'bgg-l' + this.gradientValue + '-' + this.gradientMode + '-' + color;
            }

            return bgColor;
        },

        iconClass () {
            const names = [this.icon];
            if (this.iconSize) {
                names.push('text-' + this.iconSize + 'x');
            }

            const isBgMode = this.mode === 'bg';
            const color = this.currentColor;
            const textColor = 'text-' + color;
            const bgColor = this.currentBgColor;

            if (this.iconCircle) {
                names.push('round-full');
                names.push('p-3');
            }

            if (isBgMode) {
                if (this.iconCircle) {
                    names.push('bg-2');
                    if (this.coloredIcon) {
                        names.push(textColor);
                    }
                }
            } else {
                if (this.iconCircle) {
                    names.push(bgColor);
                } else if (this.coloredIcon) {
                    names.push(textColor);
                }
            }

            return names;
        },

        numberClass () {
            const names = [];
            if (this.numberSize) {
                names.push('text-' + this.numberSize + 'x');
            }

            const isBgMode = this.mode === 'bg';
            if (!isBgMode && this.coloredNumber) {
                names.push('text-' + this.currentColor);
            }

            return names;
        },

        nameClass () {
            const names = [];
            const isBgMode = this.mode === 'bg';
            if (!isBgMode && this.coloredName) {
                names.push('text-' + this.currentColor);
            }
            return names;
        },

        /**
         *
         * Container Classes
         *
         */
        containerClass () {
            const names = ['trn-slow'];
            if (this.shadow) {
                names.push('bs-' + this.shadow);
            }

            if (this.yAxis) {
                names.push('fl-y-l');
            } else {
                names.push('fl-te-c');
            }
            if (this.iconAlignmentInvert) {
                names.push('fl-rev');
            }

            const bgColor = this.currentBgColor;
            if (this.mode === 'bg') {
                names.push(bgColor);
            }
            return names;
        },

        textContainerClass () {
            const names = [];
            if (this.iconAlignmentInvert) {
                names.push('fl-y-l');
            } else {
                names.push('fl-y-l');
            }

            if (this.yAxis) {
                if (this.iconAlignmentInvert) {
                    names.push('mb-8');
                } else {
                    names.push('mt-8');
                }
            }

            if (this.nameAlignmentInvert) {
                names.push('fl-rev');
            }

            return names;
        }
    }

};

export default StatBase;
